import React, { useState } from 'react'
import {Form} from 'react-bootstrap';
import EventToast from "../EventToast"

import CepApi from "../../api/cep"
import './style.css'

const CEP = ({data, inputs, handleChange, disabled}) => {

	const [showToast, setShowToast] = useState(false);
	const [toastError, setToastError] = useState("");

	const searchCEP = (cep) => {
		CepApi.get(cep)
		.then(response => {
			for (let key in data.fields) {
				console.log(key)
				if (key === "uf") {
					let event = {target: {name: data.fields[key], value: response.data[key].uf}}
					handleChange(event)
				} else if (key === "city") {
					let event = {
						"field": data.fields[key],
						"value": response.data["id"],
						"label": response.data[key]
					}
					handleChange(event)
				} else {
					let event = {target: {name: data.fields[key], value: response.data[key]}}
					handleChange(event)
				}
			}
		}).catch(error => {
			setShowToast(true)
			setToastError(`${error?.response?.data?.message} (${error.response?.status})`)
		})
  };

	
	return (
		<Form.Group className={data.class} controlId={data.nameForm}>
			<Form.Label>{data.name}</Form.Label>
			<Form.Control 
				required={data.required}
				type="text"
				pattern="\d*"
				placeholder={data.placeholder}
				name={data.nameForm}
				value={inputs[data.nameForm] || ''}
				onChange={e => {
					e.target.value = e.target.value.replace(/[^0-9]/g, '')
					if (e.target.value.length > 8) {
						e.target.value = e.target.value.substring(0, 8)
						return
					}
					if (e.target.value.length >= 8) {
						searchCEP(e.target.value)
					}
					handleChange(e)
				}}
				disabled={disabled}
			/>
			<EventToast
				show={showToast}
				setShow={setShowToast}
				message={`Erro ao carregar a tela: ${toastError}`}
			/>
		</Form.Group> 
	)
}

export default CEP